@if (showRegionSelector) {
	<auth-template>
		<div class="region-selector">
			<div class="region-selector__header">
				@if (canDismiss) {
					<button
						type="button"
						class="region-selector__back"
						(click)="close()"
						attr.aria-label="{{ 'common_back' | translate }}">
						<i class="ficon-arrow-left"></i>
					</button>
				}
			</div>

			<div class="region-selector__body">
				<h2 class="region-selector__title">{{ 'region-selector_title' | translate }}</h2>

				<div class="region-selector__options">
					@for (option of regionOptions; track option.key) {
						<button
							type="button"
							class="icon-btn-large region-selector__option"
							[ngClass]="option.buttonClass"
							(click)="selectRegion(option.key)"
							[attr.data-cy]="'region-selector-option-' + option.key"
							attr.aria-label="{{ option.labelKey | translate }}">
							<i [ngClass]="option.iconClass"></i>
							<span class="region-selector__option-text">
								<span class="region-selector__option-title">{{ option.labelKey | translate }}</span>
							</span>
						</button>
					}
				</div>
			</div>
		</div>
	</auth-template>
}
